export const enum ItinerarySegmentType {
  Accommodation = 'accommodation',
  Activity = 'activity',
  Car = 'car',
  EndLocation = 'endLocation',
  Ferry = 'ferry',
  Flight = 'flight',
  MiddleLocation = 'middleLocation',
  StartLocation = 'startLocation',
  Walk = 'walk',
  Cycle = 'cycle',
  Upsell = 'upsell',
  NoTransport = 'noTransport',
  UpsellNoTransport = 'upsellNoTransport',
  StenaUpsellNoTransport = 'stenaUpsellNoTransport',
  OwnStay = 'ownStay',
  DateLocation = 'dateLocation',
}
